
import { baseApi } from "./baseApi";

const DOCUMENT_BASE_URL = "/documents";

export const DocumentApi = baseApi.injectEndpoints({
  tagTypes: ["Document"],

  endpoints: (builder) => ({
    getDocumentsBySource: builder.query({
      query: (params) => ({
        url: DOCUMENT_BASE_URL,
        params,
      }),
      providesTags: (result) =>
        result?.data
          ? [
              ...result.data.map(({ _id }) => ({
                type: "Document",
                id: _id,
              })),
              { type: "Document", id: "LIST" },
            ]
          : [{ type: "Document", id: "LIST" }],
    }),

    getPendingDocumentsBySource: builder.query({
      query: (params) => ({
        url: `${DOCUMENT_BASE_URL}/pending`,
        params,
      }),
      providesTags: (result) =>
        result?.data
          ? [
              ...result.data.map(({ _id }) => ({
                type: "Document",
                id: _id,
              })),
              { type: "Document", id: "PENDING_LIST" },
            ]
          : [{ type: "Document", id: "PENDING_LIST" }],
    }),
    updateDocumentApprovalStatus: builder.mutation({
      query: ({ _id, status }) => ({
        url: `${DOCUMENT_BASE_URL}/${_id}/approval`,
        method: "PATCH",
        body: { status },
      }),
      invalidatesTags: (result, error, { _id }) => [
        { type: "Document", _id },
        { type: "Document", id: "LIST" },
        { type: "Document", id: "PENDING_LIST" },
      ],
    }),
    
    updateDocumentById: builder.mutation({
      query: (payload) => {
        const {  body } = payload;

        return {
          url: `${DOCUMENT_BASE_URL}/${body?._id}/update/document`,
          method: "PUT",
          body,
        };
      },
      invalidatesTags: (result, error, { _id }) => [
        { type: "Document", _id },
        { type: "Document", id: "LIST" },
      ],
    }),

    addDocumentSource: builder.mutation({
      query: (payload) => ({
        url: `${DOCUMENT_BASE_URL}`,
        method: "POST",
        body: payload,
      }),
      invalidatesTags: (result, error, { _id }) => [
        { type: "Document", id: "LIST" },
      ],
    }),
    addDocumentSourceForVendor: builder.mutation({
      query: (payload) => ({
        url: `${DOCUMENT_BASE_URL}/createDocumentForVendor`,
        method: "POST",
        body: payload,
      }),
      invalidatesTags: (result, error, { _id }) => [
        { type: "Document", id: "LIST" },
      ],
    }),
  }),
});

export const {
  useGetDocumentsBySourceQuery,
  useGetPendingDocumentsBySourceQuery,
  useAddDocumentSourceMutation,
  useAddDocumentSourceForVendorMutation,
  useUpdateDocumentByIdMutation,
  useUpdateDocumentApprovalStatusMutation,
} = DocumentApi;
 